// extracted by mini-css-extract-plugin
module.exports = {"custom-swiper-button-left":"swiperButton_custom-swiper-button-left__c5zvL","custom-swiper-button-right":"swiperButton_custom-swiper-button-right__9oRK2"};